// @ts-nocheck
import * as React from "react";

const OtherFasteners: React.FC = () => {
    return (
        <svg
            x="0px"
            y="0px"
            viewBox="0 0 47 47"
            enableBackground="new 0 0 47 47;"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Icon_FastenerSolutions</title>
            <g id="Icon_FastenerSolutions" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Group-2">
                    <g id="Group" fill="#1D1D1B">
                        <path
                            d="M44.034274,22.0166474 C44.034274,34.1770676 34.1780468,44.034274 22.0186059,44.034274 C9.8581857,44.034274 0,34.1770676 0,22.0166474 C0,9.85720645 9.8581857,0 22.0186059,0 C34.1780468,0 44.034274,9.85720645 44.034274,22.0166474"
                            id="Fill-5"
                        ></path>
                    </g>
                    <g id="Group-11" transform="translate(4.000000, 14.000000)" fill="#FFFFFF">
                        <path
                            d="M35.9819539,0 L1.01804612,0 C0.455441684,0 0,0.447368421 0,1 C0,1.55263158 0.455441684,2 1.01804612,2 L35.9819539,2 C36.5445583,2 37,1.55263158 37,1 C37,0.447368421 36.5445583,0 35.9819539,0"
                            id="Fill-1"
                        ></path>
                        <path
                            d="M13.0798838,5.77845528 C13.0798838,5.77845528 13.2573529,5.83333333 13.4160312,6.06910569 C13.550699,6.26930894 13.5319081,6.4898374 13.5319081,6.4898374 L13.5319081,13 L23.4680919,13 L23.4680919,6.4898374 C23.4680919,6.4898374 23.449301,6.26930894 23.5839688,6.06910569 C23.7426471,5.83333333 23.9201162,5.77845528 23.9201162,5.77845528 L30,4 L7,4 L13.0798838,5.77845528 Z"
                            id="Fill-3"
                        ></path>
                        <polygon
                            id="Fill-5"
                            points="13 16.9261134 13.8837584 16.9261134 13.8837584 19 24.1162416 19 24.1162416 16.9261134 25 16.9261134 25 15 13 15"
                        ></polygon>
                        <polygon
                            id="Fill-7"
                            points="13 22.9261134 13.8837584 22.9261134 13.8837584 25 24.1162416 25 24.1162416 22.9261134 25 22.9261134 25 21 13 21"
                        ></polygon>
                        <path
                            d="M13.8836793,31.3997598 C15.206514,31.7140284 16.5744452,31.9103044 17.9767359,31.9761079 C20.0876879,32.0759478 22.1471009,31.85925 24.115247,31.3940871 L24.115247,29.1590363 L25,29.1590363 L25,27 L13,27 L13,29.1590363 L13.884753,29.1590363 L13.8836793,31.3997598 Z"
                            id="Fill-9"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(OtherFasteners);
